import { SalesPerson } from "src/api-service";

// **************************************************************************
// SALES PERSON STATE
// **************************************************************************
export interface SalesPersonState {
    salesPerson: SalesPerson | null;
    salesPersons: SalesPerson[];
    salesPersonsLoading: boolean;
}

export const initialSalesPersonState: SalesPersonState = {
    salesPerson: null,
    salesPersons: [],
    salesPersonsLoading: false,
};
